(function () {
  const initProductAccordion = () => {
    $(".about__accordion-toggle").click(function () {
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
        $(this)
          .siblings(".about__accordion-description")
          .eq($(this).index())
          .stop()
          .slideDown(300);
      } else {
        $(this).removeClass("active");
        $(this).siblings(".about__accordion-description").stop().slideUp(300);
      }
    });
  };

  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
  });

  initProductAccordion();
})();

/*
 * Structured-data patch — 2026-08-18
 * Fixes Google Search Console "Merchant listings" non-critical issues without
 * changing any visible page content:
 *  - truncates the ProductGroup/Product description to Google's 5,000-char limit
 *  - adds a description to each variant node (Google flags these as missing)
 *  - adds hasMerchantReturnPolicy + validFrom to each offer
 *  - normalises brand to a proper {"@type":"Brand","name":...} object
 * It edits the JSON-LD Shopify already renders in the page rather than
 * replacing it, so it only ever adds/repairs fields — it never removes data.
 */
(function () {
  function fixOffer(offer, todayISO) {
    if (!offer || typeof offer !== "object") return;
    if (!offer.validFrom) {
      offer.validFrom = todayISO;
    }
    if (!offer.hasMerchantReturnPolicy) {
      offer.hasMerchantReturnPolicy = {
        "@type": "MerchantReturnPolicy",
        applicableCountry: "ZA",
        returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted",
      };
    }
  }

  function fixProductStructuredData() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    var todayISO = new Date().toISOString().slice(0, 10);

    scripts.forEach(function (el) {
      var data;
      try {
        data = JSON.parse(el.textContent);
      } catch (e) {
        return;
      }
      if (!data || (data["@type"] !== "ProductGroup" && data["@type"] !== "Product")) return;
      if (!data.hasVariant && !data.offers) return; // skip unrelated Product stubs (e.g. review widgets)

      if (typeof data.description === "string" && data.description.length > 4999) {
        data.description = data.description.slice(0, 4999);
      }
      var shortDescription = typeof data.description === "string" ? data.description.slice(0, 500) : "";

      if (data.brand && typeof data.brand === "string") {
        data.brand = { "@type": "Brand", name: data.brand };
      }

      var variants = data.hasVariant && data.hasVariant.length ? data.hasVariant : [data];

      variants.forEach(function (variant) {
        if (!variant) return;
        if (!variant.description) {
          variant.description = shortDescription;
        }
        if (variant.brand && typeof variant.brand === "string") {
          variant.brand = { "@type": "Brand", name: variant.brand };
        }
        if (Array.isArray(variant.offers)) {
          variant.offers.forEach(function (offer) {
            fixOffer(offer, todayISO);
          });
        } else {
          fixOffer(variant.offers, todayISO);
        }
      });

      el.textContent = JSON.stringify(data);
    });
  }

  document.addEventListener("shopify:section:load", function () {
    fixProductStructuredData();
  });

  fixProductStructuredData();
})();
